import React, { FC } from 'react';
import { getFormattedSettlementData, IPaginationData, ISettlementsTableRowData } from '../../interfaces/funds';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routing/routesEnums';
import { useMerchants } from '../../store/merchnts/merchants-context';

interface Props {
  listener?: (search: any) => Promise<void>;
  latestSettlementsData?: IPaginationData;
  isSettlementsDataLoading?: boolean;
}

export const LatestSettlementsList: FC<Props> = (props) => {
  const { listener, latestSettlementsData, isSettlementsDataLoading } = props;

  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const { merchantState: { isPartnerNamesListLoading }} = useMerchants();

  const rowActions = (rowData): JSX.Element => {
    const baseUrl = pathname.includes('funds') ? `${ROUTES.FUNDS}${ROUTES.SETTLEMENTS}` : ROUTES.SETTLEMENTS;
    return (
      <div
        className="text-muted cursor-pointer text-center fw-bolder fs-7"
        onClick={(): void => navigate(
          `${baseUrl}/${rowData?.original?.id}`,
          { state: { returnUrl: `${pathname}${search}` }}
        )}
      >
        Details
      </div>
    );
  };

  return (
    <Table
      name={TablesNames.settlementsTableData}
      data={getFormattedSettlementData(latestSettlementsData?.rows as ISettlementsTableRowData[]) ?? []}
      isLoading={isSettlementsDataLoading || isPartnerNamesListLoading}
      totalItemCount={latestSettlementsData?.totalItemCount}
      rowActions={rowActions}
      actionColumnsSize={50}
      queryParamsListener={listener}
    />
  );
};